import React from 'react'

import { ROUTE_NAME, API_URL } from '../constants'

import ItemDelete from '../../components/Delete'

const RoleDelete = () => (
  <ItemDelete
    routeName={ROUTE_NAME}
    apiUrl={API_URL}
    label={(item) => `Role (#${item.id}): ${item.name}`}
  />
)

export default RoleDelete
